import { Navigate, Route, Routes } from "react-router-dom"

import { AccountSettingsEmailPage } from "../pages/AccountSettingsEmailPage"
import { AccountSettingsPasswordPage } from "../pages/AccountSettingsPasswordPage"
import { AccountSettingsProfilePage } from "../pages/AccountSettingsProfilePage"

export const AccountSettingsRouter = () => {

    return (
        <Routes>
            <Route path="/" element={<AccountSettingsProfilePage />} />
            <Route path="/profile" element={<Navigate replace to="/account_settings" />} />
            <Route path="/email" element={<AccountSettingsEmailPage />} />
            <Route path="/password" element={<AccountSettingsPasswordPage />} />
            <Route path="*" element={<Navigate replace to="/account_settings" />} />
        </Routes>
    )
}